// devuelve un string con las tildes y eso borradas para búsquedas,

import { isEmpty, isNaN, isNumber } from 'lodash';

// ordenación, etc.
export function removeAccents(valor) {
  return valor.normalize('NFD').replace(/\p{Diacritic}/gu, '');
}

/**
 * Busca valorBuscar dentro de valor ignorando tildes y mayúsculas
 * @param {*} valor
 * @param {*} valorBuscar
 * @returns
 */
export function match(valor, valorBuscar) {
  if (!valor) {
    return false;
  }
  return removeAccents(valor).toLowerCase().indexOf(
    removeAccents(valorBuscar).toLowerCase(),
  ) !== -1;
}

// De momento solo de _ a -. Habrá que ampliar si necesitamos de
// CamelCase a dash, o quitar espacios etc
export function dasherize(valor) {
  return valor.replace(/_/g, '-');
}

// La inversa de dasherize. Lo mismo, habría que ampliarla
export function underscore(valor) {
  return valor.replace(/-/g, '_');
}

export function truncate(str, num) {
  return str.length > num ? `${str.slice(0, num > 3 ? num - 3 : num)}...` : str;
}

// https://stackoverflow.com/questions/36691125/lodash-isblank
export function isBlank(value) {
  return (isEmpty(value) && !isNumber(value)) || isNaN(value);
}
